// Meal type definitions with icons and display names

export type MealType = 'ontbijt' | 'lunch' | 'diner' | 'snack' | 'dessert' | 'drankje' | 'bijgerecht'

export interface MealTypeInfo {
  key: MealType
  name: string
  icon: string
  description: string
  color: string
}

export const MEAL_TYPES: MealTypeInfo[] = [
  {
    key: 'ontbijt',
    name: 'Ontbijt',
    icon: '🌅',
    description: 'Ontbijtgerechten en ochtendmaaltijden',
    color: 'bg-yellow-100 text-yellow-800'
  },
  {
    key: 'lunch',
    name: 'Lunch',
    icon: '🥪',
    description: 'Lunchgerechten en middagmaaltijden',
    color: 'bg-green-100 text-green-800'
  },
  {
    key: 'diner',
    name: 'Diner',
    icon: '🍽️',
    description: 'Dinergerechten en avondmaaltijden',
    color: 'bg-blue-100 text-blue-800'
  },
  {
    key: 'snack',
    name: 'Snack',
    icon: '🍿',
    description: 'Tussendoortjes en kleine hapjes',
    color: 'bg-purple-100 text-purple-800'
  },
  {
    key: 'dessert',
    name: 'Dessert',
    icon: '🍰',
    description: 'Nagerechten en zoete lekkernijen',
    color: 'bg-pink-100 text-pink-800'
  },
  {
    key: 'drankje',
    name: 'Drankje',
    icon: '🥤',
    description: 'Drankjes, smoothies en cocktails',
    color: 'bg-cyan-100 text-cyan-800'
  },
  {
    key: 'bijgerecht',
    name: 'Bijgerecht',
    icon: '🥗',
    description: 'Bijgerechten en side dishes',
    color: 'bg-orange-100 text-orange-800'
  }
]

export const getMealTypeInfo = (mealType?: string): MealTypeInfo | null => {
  if (!mealType) return null
  return MEAL_TYPES.find(type => type.key === mealType) || null
}

export const getMealTypeIcon = (mealType?: string): string => {
  const info = getMealTypeInfo(mealType)
  return info?.icon || '🍳'
}

export const getMealTypeName = (mealType?: string): string => {
  const info = getMealTypeInfo(mealType)
  return info?.name || 'Algemeen'
}

export const getMealTypeColor = (mealType?: string): string => {
  const info = getMealTypeInfo(mealType)
  return info?.color || 'bg-gray-100 text-gray-800'
}